import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-results-found',
  templateUrl: './no-results-found.component.html',
  styleUrls: ['./no-results-found.component.scss'],
})
export class NoResultsFoundComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() disableTitle = false;
  @Input() disableDescription = false;
}
